export const substringWords = (str: string, subStrCount: number) => {
    if (!str) return '';

    const wordLength = str.length;

    if (wordLength > subStrCount) {
        const finalWord = `${str.substring(0, subStrCount)}...`;
        return finalWord;
    } else {
        return str;
    }

    return '';
};
